export default "__VITE_ASSET__li2TlnOC__"